import {
  LookupDTO,
  RequestOtpViaMsisdnDTO,
  ValidateOtpDTO,
} from "@core/models/dto.models";
import {
  AccountCredentials,
  Email,
  Msisdn,
  PersonalDetails,
  RegistrationData,
} from "@core/models/registration.interface";
import {
  LookupApiResponse,
  RequestOtpApiResponse,
  ValidateOtpApiResponse,
  RegisterApiResponse,
  EmailApiResponse,
  RequestPepclubCheckApiResponse,
  MsisdnApiResponse,
} from "@core/models/api.response";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const registrationActions = createActionGroup({
  source: "registration",
  events: {
    "Canvasser Login": props<{ username: string }>(),
    "Terms Accepted": props<{
      termsStatus: boolean;
      marketingConsent: boolean;
    }>(),
    "Request Lookup": props<LookupDTO>(),
    "Request Lookup Success": props<LookupApiResponse>(),
    "Request Lookup Failed": props<LookupApiResponse>(),
    "Request Store Personal Details": props<PersonalDetails>(),
    "Request Check Msisdn": props<Msisdn>(),
    "Request Check Msisdn Success": props<MsisdnApiResponse>(),
    "Request Check Msisdn Failed": props<MsisdnApiResponse>(),
    "Request Pepclub check": emptyProps(),
    "Request Pepclub check Success": props<RequestPepclubCheckApiResponse>(),
    "Request Pepclub check Failed": props<RequestPepclubCheckApiResponse>(),
    "Request OTP Via Msisdn": props<RequestOtpViaMsisdnDTO>(),
    "Request OTP Via Msisdn Success": props<RequestOtpApiResponse>(),
    "Request OTP Via Msisdn Failed": props<RequestOtpApiResponse>(),
    "Request OTP Validation": props<ValidateOtpDTO>(),
    "Request OTP Validation Success": props<ValidateOtpApiResponse>(),
    "Request OTP Validation Failed": props<ValidateOtpApiResponse>(),
    "Request Email Validation": props<Email>(),
    "Request Email Validation Success": props<EmailApiResponse>(),
    "Request Email Validation Failed": props<EmailApiResponse>(),
    "Request Store Password": props<AccountCredentials>(),
    "Request Registration": emptyProps(),
    "Request Registration Success": emptyProps(),
    "Request Registration Failed": props<RegisterApiResponse>(),
    "Request Reset Intent": emptyProps(),
    "Request Reset OtpSent": emptyProps(),
    "Request Reset OtpMatch": emptyProps(),
    "Request Reset Email": emptyProps(),
    "Request Reset Password": emptyProps(),
  },
});
